<ds-modal
  #freeAllocationModal
  [dimensionsConfig]="{ width: '400px', height: 'auto' }"
  [ds-modal-trigger-for]="freeAllocationModal"
  [(isModalOpen)]="freeAllocationModalIsOpen"
  [detachFooter]="true"
>
  <ds-box-header style="font-size: xx-large; font-weight: bold">
   Free Allocation
  </ds-box-header>
  <ds-box-content>
    <span *ngIf="modalData.ind !=='X'"> Do you wish to put this vehicle <strong>{{modalData.bodyNo}}</strong> on free allocation?</span>
    <span *ngIf="modalData.ind ==='X'"> Do you wish to take unit <strong>{{modalData.bodyNo}}</strong> back from free allocation?</span>

  </ds-box-content>
  <ds-box-footer>
    <button
      ds-button
      variant="outline"
      style="margin-right: 5px"
      (click)="closeModal()"
    >
      Close
    </button>
    <button
      ds-button
      variant="primary"
      (click)="doFs(modalData.vin,modalData.bodyNo,modalData.ind)"
    >
      Confirm
    </button>
  </ds-box-footer>
</ds-modal>